import type { JSX } from 'react';
import { Link } from 'react-router';

import styles from './styles.module.css';

export function CtaBand(): JSX.Element {
  return (
    <section className={`${styles.secPad} ${styles.ctaBand}`}>
      <div className={styles.wrap}>
        <div className={styles.ctaBandInner}>
          <div>
            <h2>Ready to refer a patient?</h2>
            <p>
              No account needed. The secure, HIPAA-compliant referral form takes about 5 minutes —
              search your NPI to auto-fill your details, and we'll take it from there.
            </p>
          </div>
          <Link to="/refer" className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}>
            Open the referral form →
          </Link>
        </div>
      </div>
    </section>
  );
}
